import React from 'react';
import { hot } from 'react-hot-loader';
import Newsletter from '../../Footer/Newsletter';
import Breadcrumbs from '../../Category/Breadcrumbs';

const Placeholder = ({ content }) => {
	if (content?.placeholder === 'newsletter') {
		const [value = '', currency = ''] = (content?.leadValue || '').split(' ');
		const extraData = {
			requiredFields: content?.requiredNewsletterFields,
			optionalFields: content?.optionalNewsletterFields,
			lead: content?.lead,
			leadValue: { value, currency },
			terms: content.terms,
		};
		return <Newsletter includeDetails isBlock {...extraData} />;
	}
	if (content?.placeholder === 'breadcrumbs') {
		return <Breadcrumbs placeholder />;
	}

	return null;
};

export default hot(module)(Placeholder);
